<div [ngStyle]="{ 'padding-bottom': '8px' }" *ngIf="router.url === '/'" class="speciality-container">
    <div class="title-container"></div>
    <!-- routerLink="/specialitydoctors/{{ speciality.id }}" - class= speciality element routerLinkje -->
    <div class="speciality">
        <div class="spec">
            <div routerLink="/consultation/{{ speciality.id }}" *ngFor="let speciality of specialities; let i = index"
                class="speciality-element">
                <div class="name-container">
                    <div class="name">
                        <div>
                            <img [src]="speciality.imageUrl" />
                        </div>
                        <p>{{ speciality.name | uppercase }}</p>
                    </div>
                </div>
            </div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
        </div>
    </div>
</div>

<div *ngIf="router.url !== '/'" [ngStyle]="{ 'align-items': 'center' }" class="speciality-container">
    <div [ngStyle]="{ width: '100%', 'align-items': 'center' }" class="title-container">
        <div class="title">
            <div class="choose-container">
                <div class="choose-map">
                    <div class="choose">
                        <h1>Válasszon egészségügyi szolgáltatásaink közül!</h1>
                    </div>
                    <div class="choose">
                        <h3>Kényelmes időpontfoglalás és szakszerű ellátás</h3>
                    </div>
                    <div class="choose">
                        <p>
                            A Regenero budapesti magán egészségügyi központban az Ön egészsége a legfontosabb számunkra!
                            Tapasztalt orvosi
                            csapatunk és modern felszereléseink biztosítják, hogy a legmagasabb szintű ellátásban
                            részesüljön. A személyre
                            szabott figyelem és gyors, kényelmes szolgáltatások mind azt a célt szolgálják, hogy Ön a
                            legjobb formáját
                            hozhassa.
                        </p>
                    </div>
                    <div class="choose">
                        <p>Keressen minket bátran, szívesen segítünk, vagy az alábbi gombra kattintva is ellátogathat
                            hozzánk!</p>
                    </div>
                    <div [ngStyle]="{ 'margin-top': '16px' }" class="choose">
                        <a (click)="settingUpLinkToGoogleAnalytics()" href="{{ bookAppointmentsUrl }}"
                            target="_blank">IDŐPONT FOGLALÁSA</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div [ngStyle]="{ width: '90%' }" class="speciality">
        <div class="spec">
            <div routerLink="/consultation/{{ speciality.id }}" *ngFor="let speciality of specialities; let i = index"
                class="speciality-element">
                <div class="name-container">
                    <div class="name">
                        <div>
                            <img [src]="speciality.imageUrl" />
                        </div>
                        <p>{{ speciality.name | uppercase }}</p>
                    </div>
                </div>
            </div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
            <div class="placeholder"></div>
        </div>
    </div>
    <div class="reserve-container">
        <div class="reserve">
            <div class="res">
                <h2 [ngStyle]="{ 'text-align': 'center' }">Miért válassza a mi rendelőnket?</h2>
            </div>
            <div class="res">
                <p>Egészségügyi központunkban minőségi szolgáltatást nyújtunk, ahol Ön az első!</p>
            </div>
            <div class="res">
                <ul>
                    <li>Magas színvonalú szakellátás, személyre szabott kezelésekkel</li>
                    <li>Kiváló, folyamatosan fejlődő és bővülő orvosi csapatunk az Ön rendelkezésére áll</li>
                    <li>Kényelmes, gyors bejelentkezési online időpontfoglaló rendszerünkön keresztül</li>
                    <li>
                        Magánorvosi rendelés keretein belül várjuk kedves pácienseinket az Önnek megfelelő időpotban,
                        gyors sorrakerüléssel
                    </li>
                    <li>Nem kell külön laborba mennie, házon belül intézzük őket</li>
                </ul>
            </div>
            <div class="res">
                <p>
                    Biztosak vagyunk benne, ha a mi szakrendeléseinket választja, gyors szakértői választ kaphat
                    egészségével kapcsolatos
                    kérdéseire!
                </p>
            </div>
            <div class="res">
                <p>Ne habozzon, az Ön egészsége számunkra a legfontosabb!</p>
            </div>
            <div [ngStyle]="{ 'margin-top': '16px', 'text-align': 'center' }" class="res">
                <a (click)="settingUpLinkToGoogleAnalytics()" href="{{ bookAppointmentsUrl }}" target="_blank">FOGLALJON
                    HOZZÁNK IDŐPONTOT!</a>
            </div>
        </div>
    </div>
    <div class="feedback-container">
        <div class="feedback-title-container">
            <div class="title">
                <h2>Pácienseink visszajelzései</h2>
            </div>
        </div>

        <div class="feedback">
            <div class="feedback-part">
                <div class="feedback-text">
                    <span>„A belépésem pillanatától mindenki nagyon kedves, mosolygós, segítőkész volt. A váró kellemes,
                        melegséget sugárzó
                        helyiség volt. Pár percet töltöttem ott, de minden tipp-topp volt.”</span>
                </div>
            </div>

            <div class="feedback-part">
                <div class="feedback-text">
                    <span>„Nagyon rég nem találkoztam ennyire empatikus, kedves, alapos orvossal! Részletes, mindenre
                        kiterjedő diagnózist
                        állított fel. A vizsgálat végeztével sem engedte el a kezem. Szívből ajánlom Szőke doktor
                        urat!”</span>
                </div>
            </div>
            <div class="feedback-part">
                <div class="feedback-text">
                    <span>„Tiszta, rendezett rendelő pár lépésre a Lehel téri metró megállótól. Korrekt, kedves
                        ügyintézés.”</span>
                </div>
            </div>
            <div class="feedback-part">
                <div class="feedback-text">
                    <span>„Dr Gács Zsófiához volt időpontunk. A doktornő egyszerűen fantasztikus! Rendkívül alapos,
                        felkészült, a téma igazi
                        szakértője. A lányommal nagyon kedves és türelmes volt. Minden kérdésemet megválaszolta,
                        kétségeimet eloszlatta.
                        Bárcsak több hozza hasonló orvos lenne… Abszolút ajánlom!!”</span>
                </div>
            </div>
            <div class="feedback-part">
                <div class="feedback-text"><span>„Tisztaság, nyugalom! Kedves, hozzáértő személyzet. Jó
                        megközelíthetőség.”</span></div>
            </div>
        </div>
    </div>
</div>